import {EventManager} from "shared/utilities/Events/EventManager";
import {GetControlOptions} from "InternalShared/Events/GetControlOptions";
import {GetControl} from "InternalShared/Events/GetControl";
import {PRPDFControlFactory, PRPDFControlOptionsFactory} from "./PRControlFactory";


export class Bootstrap {
    constructor(){
        EventManager.Subscribe(GetControlOptions,e=>PRPDFControlOptionsFactory.GetControlOptions(e.Type));
        EventManager.Subscribe(GetControl,e=>PRPDFControlFactory.GetControl(e.Type));
    }
}
new Bootstrap();